<div class="">
  <label id="lbl-{{dtaQuestions.name}}" class="lbl lbl-question"for="{{dtaQuestions.name}}">{{dtaQuestions.name}}</label>
  <input matInput [matDatepicker]="picker" type="{{dtaQuestions.type}}" class="presenter" id="{{dtaQuestions.name}}" name="{{dtaQuestions.name}}" value="{{dtaQuestions.answers}}" placeholder="{{dtaQuestions.description}}">  
   <!-- [min]="minDate" [max]="maxDate" -->
  <mat-datepicker-toggle  style="position: absolute; margin: -5%; margin-top: -0.5%;" matSuffix [for]="picker" ></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</div>
<!--  -->